import React from "react";
import { ErrorBoundaryContextProvider } from '@/presentation/providers/error-boundary-provider';
import ProfilesFormWrapper from "@/presentation/pages/profiles/profiles-form-wrapper";
import { KiverascapeLayout } from "@/presentation/layouts/kiverascape-layout";
import { Flashbar } from "@cloudscape-design/components-themed/components";
import { useNotifications } from "@/presentation/providers/notifications-provider";
import { makeBreadcrumbsFromURLPath, } from "@/presentation/components/commons/breadcrumbs";
import { ProfilesHandlersProvider } from "@/presentation/providers";
import { useLocation } from "react-router-dom";
const MakeProfilesFormWrapper = (props) => {
    const { notifications } = useNotifications();
    const location = useLocation();
    const breadCrumbs = makeBreadcrumbsFromURLPath(location === null || location === void 0 ? void 0 : location.pathname);
    return (React.createElement(ErrorBoundaryContextProvider, null,
        React.createElement(KiverascapeLayout, { breadcrumbMenu: breadCrumbs, notifications: React.createElement(Flashbar, { items: notifications, 
                // @ts-ignore
                stackItems: true }), content: React.createElement(React.Fragment, null,
                React.createElement(ProfilesHandlersProvider, null,
                    React.createElement(ProfilesFormWrapper, Object.assign({}, props)))), contentType: "default" })));
};
export default MakeProfilesFormWrapper;
